// import { ImoSearchResult } from 'webcommon/shared';

export abstract class ImoSearchModalService {
  // TODO fix patient type and return type
  abstract openModal(patient: any, searchText: string, multiSelect?: boolean): any; // Promise<ImoSearchResult>;
  abstract openModalOnly(patient: any, searchText: string, multiSelect?: boolean): any; // Promise<ImoSearchResult>;
}

export function ImoSearchModalServiceFactory(i: angular.auto.IInjectorService) {
  return i.get<ImoSearchModalService>('FncImoModal');
}

export const ImoSearchModalAjsProvider = {
  deps: ['$injector'],
  provide: ImoSearchModalService,
  useFactory: ImoSearchModalServiceFactory,
};
